<template>
  <!--
    https://github.com/sagalbot/vue-select - Docs

  -->
  <vue-select
    :class="{
      'placeholder-not-showing': !showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': isDisabled,
      'vue-select__medium': isMedium
    }"
    :options="options"
    :placeholder="placeholder"
    :value="fullValue"
    @input="emitInput"
    :multiple="false"
    :clear-on-select="false"
    :hide-selected="true"
    :label="label"
    track-by="name"
    :debounce="250"
    :disabled="isDisabled"
    :on-search="searchOptions"
    :loading="loading"
    @search:focus="checkPosition"
    @search:blur="clearOptionsIfEmpty"
    :clearable="isClearable"
    :noDrop="options.length === 1 || !clearable"
  ></vue-select>
</template>

<script>
import VueSelect from 'vue-select'

const SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
}

export default {
  components: {
    VueSelect
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    label: {
      type: String,
      default: 'Name'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    returnValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      selectedValue: null
    }
  },
  computed: {
    showPlaceholder () {
      return !this.fullValue
    },
    fullValue () {
      return this.value && this.returnValue ? this.options.filter(v => v.value === this.value)[0] : this.value
    },
    hasSameReturnValue () {
      if (this.returnValue) {
        return this.value === this.selectedValue.value
      } else {
        return this.value === this.selectedValue
      }
    },
    isMedium () {
      return this.size === SIZE.MEDIUM
    },
    isDisabled () {
      return this.options.length === 1 || this.disabled
    },
    isClearable () {
      return !this.isDisabled && this.clearable
    }
  },
  methods: {
    preventTheDefault (e) {
      // Prevent enter key press to select an advertiser from submitting the form
      // This is a fix for the vue-select plugin
      if (e.keyCode === 13) {
        e.preventDefault()
      }
    },
    clear () {
      // will update the value as well
      this.selectedValue = null
      this.$emit('input', null)
    },
    emitInput (val) {
      this.$emit('input', this.returnValue ? (val ? val.value : val) : val)
    },
    clearOptionsIfEmpty () {
      if (!this.value) {
        this.$emit('clearOptions')
      }
    },
    checkPosition () {
      setTimeout(() => {
        const windowBottom = window.innerHeight
        const dropdownMenu = this.$el.querySelector('.dropdown-menu')
        if (dropdownMenu) {
          const dropdownMenuBounds = dropdownMenu.getBoundingClientRect()
          const dropdownMenuBottom = dropdownMenuBounds.bottom
          const dropdownMenuCalculatedBottom = dropdownMenuBounds.y + dropdownMenuBounds.height
          const dropdownMenuCalculatedHeight = windowBottom - dropdownMenuBounds.y
          if (dropdownMenuCalculatedBottom > windowBottom) {
            dropdownMenu.style.height = `${dropdownMenuCalculatedHeight - 5}px`
          }
        }
      }, 0)
    }
  },
  watch: {
    options: function () {
      if (this.options.length === 1) {
        this.emitInput(this.options[0])
      }
      this.checkPosition()
    }
  },
  mounted () {
    this.searchInput = this.$el.querySelector('input[type=search]')
    this.searchInput.addEventListener('keypress', this.preventTheDefault)
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// StyledSelectVModel.vue?be377028